"use client";

import { enUS, jaJP } from "@clerk/localizations";
import { ClerkProvider } from "@clerk/nextjs";
import { dark } from "@clerk/themes";
import { useTheme } from "next-themes";
import { type ReactNode } from "react";

type Props = {
  locale: string;
  children: ReactNode;
};

export function Providers({ locale, children }: Props) {
  const { resolvedTheme } = useTheme();

  return (
    <ClerkProvider
      signInUrl="/auth"
      localization={locale === "en" ? enUS : jaJP}
      appearance={{ baseTheme: resolvedTheme === "dark" ? dark : undefined }}
    >
      {children}
    </ClerkProvider>
  );
}
